import React from 'react';
import { Box } from '@mui/material';
import { AU, RADIO_TARJETA } from '../../styles/tokensAU';

// Tarjeta azul suave, sin borde: el relleno ya la separa del fondo y hay menos líneas en pantalla.
const TarjetaAU = ({ children, component = 'section', sx, ...resto }) => (
  <Box
    component={component}
    sx={[
      {
        bgcolor: AU.azulSuave,
        border: 0,
        borderRadius: RADIO_TARJETA,
        p: { xs: 2, sm: 2.5 },
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
    {...resto}
  >
    {children}
  </Box>
);

export default TarjetaAU;
